import {btbIndustry, designSizeOptions} from './constants.js';

export const getTplOptions = e => {
    const {groupKey = 'templateGroup'} = e;
    const btbSize = ['3:2', '1:1', '3:4', '3:1', '9:16'];
    const otherSize = ['16:9', '1:1', '3:2', '3:4', '3:1', '9:16'];
    const {ext: {industryList}, formData: {[groupKey]: {industry}}} = e;
    const isBtB = industryList.length
        && btbIndustry.includes(industryList.find(item => item.value === industry.value)?.label);
    const sizeOptions = designSizeOptions.filter(option =>
        (isBtB ? btbSize : otherSize).includes(option.value)
    );

    return sizeOptions;
};

// 分组，将相同的key归类到一起，其他按顺序排列
export const groupDuplicatesByKey = (data, key) => {
    const keyMap = new Map();
    // 首先将每个项按 id 分组
    data.forEach(item => {
      if (!keyMap.has(item[key])) {
        keyMap.set(item[key], []);
      }
      keyMap.get(item.id).push(item);
    });

    // 创建一个新的数组存储处理过后的数据
    const result = [];

    // 遍历原始数据，将非重复的项先加入结果数组
    data.forEach(item => {
      if (keyMap.has(item[key])) {
        // 先将当前 id 的所有项移入结果数组
        const group = keyMap.get(item[key]);
        group.forEach(groupItem => {
          if (!result.includes(groupItem)) {
            result.push(groupItem);
          }
        });
        // 清空当前 id 的项，避免重复加入
        keyMap.delete(item[key]);
      }
    });
    return result;
};